import { MutationTree } from 'vuex'
import { CompanyState, UICompanyModel } from './companies.model'

export enum MutationTypes {
  GET_COMPANIES_REQUEST = 'GET_COMPANIES_REQUEST',
  GET_COMPANIES_SUCCESS = 'GET_COMPANIES_SUCCESS',
  GET_COMPANIES_ERROR = 'GET_COMPANIES_ERROR'
}

export const mutations: MutationTree<CompanyState> = {
  [MutationTypes.GET_COMPANIES_REQUEST](state) {
    state.loading = true
  },
  [MutationTypes.GET_COMPANIES_SUCCESS](state, companies: Array<UICompanyModel>) {
    state.loading = false
    state.companies = companies
  },
  [MutationTypes.GET_COMPANIES_ERROR](state, error) {
    state.errorMessage = error.message
    state.loading = false
    state.companies = []
  }
}
